import { render, staticRenderFns } from "./EntregaInfo.vue?vue&type=template&id=07700ed4&scoped=true"
import script from "./EntregaInfo.vue?vue&type=script&lang=js"
export * from "./EntregaInfo.vue?vue&type=script&lang=js"
import style0 from "./EntregaInfo.vue?vue&type=style&index=0&id=07700ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07700ed4",
  null
  
)

export default component.exports